<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Protocolos sugeridos"
    >
        O CID identificado possui os seguintes protocolos para atendimento:

        <rkm-table
            :fields="fields"
            :items="ocis"
            class="mt-3"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="ativarOci(item.id)"
                    color="primary"
                    small
                    title="Ativar protocolo"
                >
                    <rkm-icon icon="check" />
                </rkm-button>
            </template>
        </rkm-table>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Cancelar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    created() {

        this.repositories = {
            atendimento: this.getConectaSusRepository('ambulatorio.atendimento'),
        }
    },
    data: () => ({
        ocis: [],
        fields: [
            { key: 'nome', label: 'Nome', sortable: true },
            { key: 'linhaCuidado', label: 'Linha de cuidado', sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ]
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(ocis) {

            this.ocis = ocis

            this.$refs.RkmModal.show()
        },
        ativarOci(id) {

            this.setLoading()

            this.repositories.atendimento.getOci(id)
                .then(({ data }) => {

                    this.data.ociModel.oci = data

                    this.$refs.RkmModal.hide()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [repository, error],
    props: {
        data: {type: Object, required: true},
    },
}
</script>